<template>
    <div>
        <v-card class="rounded-lg" elevation="0">
            <v-tabs fixed-tabs background-color="#41916b" dark>
            <v-tabs-slider color="#b1e3cc"></v-tabs-slider>
                <v-tab><v-icon style="padding:10px">mdi-call-made</v-icon>DISTRIBUIÇÃO/DISPONIBILIZAÇÃO</v-tab>

            <v-tab-item>
              <v-card-text>
                <v-form @submit.prevent="search()" ref="searchDonor">
                  <p class="space-personalized"></p>
                  <v-container>
                    <v-row dense>
                      <v-col class="d-flex" cols="12" sm="4">
                        <v-select
                         :items="sex"
                         item-value="id"
                         item-text="name"  
                         color="#086318" 
                         label="Buscar Por Orgão" 
                         placeholder="Nome do Orgão" 
                         class="rounded-lg"
                         outlined 
                         v-model="name"
                         dense>
                        </v-select>
                      </v-col>

                      <v-col class="d-flex" cols="12" sm="1">
                        <v-btn elevation="1" fab small color="#41916b" @click="search()">
                            <span class="textBtn"><v-icon>mdi-magnify</v-icon></span>
                        </v-btn> 
                        <v-btn class="ml-2" elevation="1" color="grey" fab small @click="clear()">
                            <span class="textBtn"><v-icon>mdi-broom</v-icon></span>
                        </v-btn>
                      </v-col>
                      <v-spacer/>

                      <v-btn class="rounded-lg" elevation="1" color="#41916b" @click="$router.push('/disponibilizacao-doador')">
                        <v-icon class="mr-2" color="#FFFFFF">mdi-plus</v-icon>
                        <span class="textBtn text-truncate" :style="{'max-width': $vuetify.breakpoint.smAndDown ? '100px' : '100%'}"> DISPONIBILIZAR/DISTRIBUIR ORGÃOS </span>
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
   
              <v-data-table
                :headers="headers"
                :items="teste"
                :footer-props="{'items-per-page-text': 'Doador por Página',}"
                :page="page"
                :loading="loading">

                <template v-slot:[`item.value`]="{ item }">
                  <TagTipoCaptacao :resource="item"/>
                </template>
        
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip left color="green">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        size="22"
                        class="icon"
                        color="#41916b" 
                        v-on="on"
                        v-bind="attrs"
                        align-item="center"
                        @click="redirect(item)">mdi-eye
                      </v-icon>
                    </template>
                      <span style="color:white">{{$t('buttons.edit')}}</span>
                    </v-tooltip> 
                </template>
                
              </v-data-table>
           </v-tab-item>
        </v-tabs>
        </v-card>
    </div>
</template>

<script>
  import axios from "@/axios";
  import currentUser from "@/utils/currentUser";
  import { profileSlug } from "@/helpers/profileSlug";
  export default {
    data() {
      return {
        dialog: false,
        headers: [
          {
            text: "Orgão",
            align: "center",
            value: "name",
          },

          {
            text: "Disponibilizados",
            align: "center",
            value: "value",
          },

          {
            text: "Descartados",
            align: "center",
            value: "value",
          },

          { text: "Ações", value: "actions", sortable: false,  align: "center" },
        ],

        displayError: {
          display: false,
          message: [],
        },
        page: 1,
        numberOfPages: 0,
        loading: true,
        options: {},
        sortBy: "name",
        donorCaptations: [],
        teste: [],
        message: "",
        name: "",
        snackbar: false,
        loadingBTN: false,
        exibirMensagem: false,
        messageError: "",
      };
    },
    
    created() {
      this.loadTable();
    },

    watch: {
      sortBy: {
        handler() {
  
        }
      },
      options: {
        handler() {
          this.loadGridData();
        },
      },
      deep: true,
    },

    computed:{
      currentUser(){
        return currentUser.getUserData()
      },

      profile() {
        return this.currentUser.profile
      },

      profile_slug(){
        return profileSlug(this.profile)
      }
    },
  
    methods: {
      
      loadTable(){
        axios.get("/donor/allCaptations").then((response) => {
          const data = response.data.data; 

          const filteredData = this.profile_slug == "admin" ? data : data.filter(x => x.unity_id == this.currentUser.unity_id);
 
          const captation = filteredData.filter(x => x.captation != null);
          const pcrDonorData = filteredData.filter(x => x.pcr_donor_data != null);
 
          this.donorCaptations = captation.concat(pcrDonorData);

          this.loading = false;
        });
      },

      redirect(item){
        const path = item.captation ? "/editar-captacao" : "/captacao-pcr";

        this.$router.push({ path, query: { item }});
      },

      clear(){
        this.name = ""
        this.loading = true;
        this.loadTable();
      },

      search() {
      const donor = new Object();
        donor.name = this.name;
          axios.post("/captation/filter", donor).then((response) => {
            this.loading = true;
            this.donorCaptations = response.data.data; 
            this.loading = false;
        });
      },
      
    },
  };
  </script>
  
  <style scoped>
  .header-table {
    display: flex;
    margin-bottom: 20px;
  }

  .d-flex{
    padding: 0 12px;
  }
  
  .space {
    width: 5px;
  }

  .space-personalized{
  padding: 9px;
  }

  .spacediferent {
  width: 7px;
}
  .v-btn:not(.v-btn--round).v-size--default {
    height: 40px !important;
  }
  
  .textBtn {
    font-family: "Poppins";
    color: #ffffff;
  }
  
  .create-user-dialog {
    padding: 20px;
  }
  
  .card {
    padding: 35px;
  }
  
  .banner {
    background: #b3ffab; /* fallback for old browsers */
    background: -webkit-linear-gradient(
      to right,
      #27ae60,
      #1abc9c
    ); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(
      to right,
      #ee106d,
      #e46987
    ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  
    border-radius: 8px;
  
    margin-bottom: 20px;
  
    display: flex;
    align-items: center;
  }
  
  .icon{

  }

  .banner > h4 {
    color: #ffffff;
    padding: 10px;
  }
  
  .cardFooter {
    padding: 0 !important;
  }
  </style>
  